<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-22 20:11:13
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-03-22 20:14:01
 * @FilePath: /dsicm-admin-web/src/views/Organization/components/ChangeRadio.vue
-->
<template>
    <el-radio label="1"></el-radio>
</template>

<script>
export default {
    props:['row','column'],

    methods:{
        changeRadio(){
            this.$emit('row-radio', this.row)
        }
    }
}
</script>